import { Component, OnInit, AfterViewInit, ViewChild, Input, Host } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Subscription, combineLatest } from 'rxjs';
import { filter, mergeMap, tap } from 'rxjs/operators';
//import { GridOptions, ColDef,} from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, } from 'ag-grid-community';

import { TabComponent } from '../../../tabs/tab.component';
import { TabsComponent } from '../../../tabs/tabs.component';

import { IssuesService, IssueSearchSpec } from '../../../../services/issues.service';
import { WellService } from '../../../../../common/services/well.service';
import { RouterLinkRendererComponent } from "../../../../../common/components/ag-grid/router-link-renderer.component";
import { CheckboxRendererComponent } from "../../../../../common/components/ag-grid/checkbox-renderer.component";
import { GISPoint, GISPointTypes, Well, WellPermittingModifiers, WellWithFinancialAssurance } from '../../../../../common/models/well.model';
import { Issue, IssuesConfig } from '../../../../models/issue.model';
import { Organization } from '../../../../../common/models/organization.model';
import { GridFormatterService } from '../../../../services/grid-formatter.service';
import { AgGridAngular } from 'ag-grid-angular';
import { AgGridBooleanFilterComponent, IBooleanFilterParams } from '../../../ag-grid/filters/boolean-filter.component';
import { FlaggedComponent } from '../../../data-table/columns/flagged/flagged.component';
import { WellDirection } from '../../../../../form-controls/components/new-casing-plan/models/casing-plan.model';
import { DetailsComponent } from '../../../data-table/columns/details/details.component';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { DomainValue } from '../../../../../models/domain.model';
import { dateComparator } from '../../../data-table/comparators/data-table.comparators';
import { OrganizationWellsGridComponent } from "./organization-wells-grid.component";

@Component({
    selector: 'organization-wells',
    templateUrl: './organization-wells.component.html',
    styleUrls: ['./organization-wells.component.scss'],
    standalone: false
})
export class OrganizationWellsComponent implements AfterViewInit, OnInit {
    @Input() organization: Organization;
	@ViewChild(OrganizationWellsGridComponent, { static: true })  public _table: OrganizationWellsGridComponent;
    data: WellWithFinancialAssurance[];
    wellIssues: Issue[];
    _wellIds: string[];
    dataSubscriptions: Subscription = new Subscription();

    _wellHasIssueColumn: ColDef;

    config: IssuesConfig;


    constructor(
        public _wellService: WellService,
        public _router: Router,
        public _activatedRoute: ActivatedRoute,
        @Host() public _tabs: TabsComponent,
        @Host() public _tab: TabComponent,
        public _issuesService: IssuesService,
        public _gridFormatterService: GridFormatterService,
        public _domainService: DomainDefinitionService,
        private datePipe: DatePipe
    ) {
        this.config = window["issuesConfig"];
        this._tabs.tabClicked.subscribe((result) => {
            if (result === this._tab)
                this._table.api.sizeColumnsToFit();
        })
    }


    ngOnInit() {

		let dataSubs$ = this._wellService.getWellsForOrganizationWithFinancialAssuranceFlags(this.organization.id, this.organization.historicalOwnerNumber)
			.subscribe(
				(wells: WellWithFinancialAssurance[]) => {
					this.data = wells;
					this.fetchWellIssues;
				},
				(err) => {
					console.error(err);
				});
		this.dataSubscriptions.add(dataSubs$);

        this._router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.dataSubscriptions.unsubscribe();
        });
    }

    ngOnDestroy() {
        if (this.dataSubscriptions) {
            this.dataSubscriptions.unsubscribe();
        }
    }

    ngAfterViewInit() {
    }

    exportWells(): void {
		this._table.exportWells();
    }

    hasIssues(returnTooltip: boolean = false): any {
        return (obj) => {
            let hasOpenIssue = false;
            let matchingWellIssues: Issue[];
            if (obj && obj.data && obj.data.id) {
                matchingWellIssues = this.wellIssues.filter(a => a.wellId == obj.data.id);
                if (matchingWellIssues.length > 0)
                    hasOpenIssue = true;
            }

            if (returnTooltip)
                return hasOpenIssue ? "Well has open Issues : " + matchingWellIssues[0].description : "Well has no open issues";
            else
                return hasOpenIssue ? true : " ";     
        }
    }

    buyerLacksFA(returnTooltip: boolean = false): any {
        return (obj) => {
            let buyerLacksFa = false;

            if (obj.data && obj.data.faOrganizationId != null && obj.data.faOrganizationId != undefined && obj.data.faOrganizationId != "")
                buyerLacksFa = true;

            if (returnTooltip)
                return buyerLacksFa ? "Buyer Lacks Necessary FA" : "Buyer Has Necessary FA";
            else
                return buyerLacksFa;
        }
    }

    private fetchWellIssues(): void {
        this._wellIds = this.data.map(a => a.id);

        let issueSearchSpec = {
            issueIsResolved: false,
            wellIds: this._wellIds
        } as IssueSearchSpec;

        var wellsLackingBuyerFA = this.data.filter(a => a.faOrganizationId && (a.faOrganizationId == this.organization.id || a.faOrganizationId == this.organization.historicalOwnerNumber));
        if (wellsLackingBuyerFA.length > 0) {
			this._table.addBuyerFAColumn();
        }
        const showIssues: boolean = this.config.showIssuesContent.toString().toLocaleLowerCase() === 'true';
        if (showIssues) {
            this.dataSubscriptions.add(this._issuesService.getIssues(issueSearchSpec).subscribe(issues => {
                this.wellIssues = issues;
                if (this._wellIds) {
                    var wellsHaveOpenIssues = this._wellIds.filter(a => issues.some(b => b.wellId == a));
                    if (wellsHaveOpenIssues.length > 0) {
						this._table.addIssuesColumn();
                    }
                }
            },
                error => { console.log(error); console.log("ERROR Fetching the wells and related issues for this org."); }
            ));
        }
    }
}
